import { Link } from "react-router-dom";

const FooterOne = () => {
  return (
    <>
      <footer className="footer-section">
        <img
          src="assets/images/shapes/pattern.png"
          alt=""
          className="bg-pattern"
        />
        <img
          src="assets/images/shapes/element1.png"
          alt=""
          className="element one"
        />
        <img
          src="assets/images/shapes/element2.png"
          alt=""
          className="element two"
        />
        <img
          src="assets/images/gradients/footer-gradient.png"
          alt=""
          className="bg--gradient"
        />
        <div className="container container-two">
          <div className="row gy-5">
            <div className="col-xl-4 col-sm-6">
              <div className="footer-widget">
                <div className="footer-widget__logo">
                  {/* <Link to="/">
                    <img src="assets/images/logo/xervises-logo.png" alt="" />
                  </Link> */}
                </div>
                <p className="footer-widget__desc">
                  Get in touch with us today at Xervises — your partner for
                  website themes, reliable hosting, and backend API server
                  solutions. Our team is ready to help with your project setup
                  and support needs.
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-sm-6 col-xs-6">
              <div className="footer-widget">
                <h5 className="footer-widget__title text-white">Useful Link</h5>
                <ul className="footer-lists">
                  <li className="footer-lists__item">
                    <Link to="/premium-themes" className="footer-lists__link">
                      Premium Theme
                    </Link>
                  </li>
                  <li className="footer-lists__item">
                    <Link to="/cloud-services" className="footer-lists__link">
                      Cloud Server
                    </Link>
                  </li>
                  <li className="footer-lists__item">
                    <Link to="/contact" className="footer-lists__link">
                      Contact
                    </Link>
                     <li className="footer-lists__item">
                    <Link to="/tools" className="footer-lists__link">
                      Essential tools
                    </Link>
                  </li>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-sm-6">
              <div className="footer-widget">
                <h5 className="footer-widget__title text-white">Subscribe</h5>
                <p className="footer-widget__desc">
                  Subscribe our newsletter to get updated the latest news
                </p>
                <form
                  action="#"
                  className="mt-4 subscribe-box d-flex align-items-center flex-column gap-2"
                >
                  <input
                    type="text"
                    className="form-control common-input pill text-white"
                    placeholder="Enter Mail"
                  />
                  <button
                    type="submit"
                    className="btn btn-main btn-lg w-100 pill"
                  >
                    Subscribe Now
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterOne;
